/**
 * An empty messages object suitable for fulfilling the i18n service's contract.
 * @memberof module:Testing
 */
const messages = {
  ar: {},
  'es-419': {},
  fa: {},
  'fa-ir': {},
  fr: {},
  'zh-cn': {},
  ca: {},
  he: {},
  id: {},
  'ko-kr': {},
  pl: {},
  'pt-br': {},
  ru: {},
  th: {},
  uk: {},
};

export default messages;
